import React from 'react'
import LiveDate from 'src/components/LiveDate'

import { Flex, Box, Text } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import { RecentDiscussionsType } from '../../types/index'

type Props = {
  recentDiscussions: RecentDiscussionsType[]
}

const RecentDiscussions: React.FC<Props> = ({ recentDiscussions }) => {
  return (
    <Flex flexDirection="column" alignItems="center" mt="2x">
      <Flex alignSelf="flex-start" mb="2x">
        <Text variant="text.h5" as="h5">
          {t('Recent discussions')}
        </Text>
      </Flex>

      <Flex flexDirection="column" alignItems="flex-start">
        {recentDiscussions.map(
          ({ title, url, lastPostedAt, categoryName, categoryLogo }: any) => {
            return (
              <Flex flexDirection="column" key={lastPostedAt} mt="2x">
                <Box width="50px" mr="1x">
                  {categoryLogo && (
                    <img src={categoryLogo} alt={categoryName} width="50px" />
                  )}
                </Box>
                <Box>
                  <a href={url}>{title}</a>
                  <br />
                  <Text fontSize="sm">
                    {categoryName}
                    {' - '}
                    <LiveDate date={lastPostedAt} format="fromNow" />
                  </Text>
                </Box>
              </Flex>
            )
          }
        )}
      </Flex>
    </Flex>
  )
}
export default RecentDiscussions
